exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".apply .wrapper .application .app-display .left-side .info .inputs input[type=text].coapplicants-input{box-shadow:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./directives/freeforms/coapplicants/coapplicants.css
// module id = 367
// module chunks = 0